<template>
    <div class="app-container">
        <CriteriaTitleB />
        <CriteriaCardB />
    </div>
</template>

<script setup>
import CriteriaTitleB from './CriteriaTitleB.vue'
import CriteriaCardB from './CriteriaCardB.vue'
</script>

<style scoped>
.app-container {
    /* padding-top: 20px; */
    background: #fff9f1;
}
</style>